import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { responseTimeInCommunity } from '../../../store/actions/UserAction';
import './CardResponseTime.scss';

const CardResponseTime = ({ authClient }) => {

  const [didCheck, setDidCheck] = useState(false)

  useEffect(() => {
    if (!didCheck) {
      try {
        responseTimeInCommunity(authClient.uid)
        setDidCheck(true)
      } catch (error) {
        console.log('error', error);
      }
    }
  }, [authClient.uid, didCheck])

  return (
    <>
      <section className="cardResponseTime">
        <header className="cardResponseTime_header">
          <p className="cardResponseTime_title">Comunidad</p>
        </header>
        <div className="cardResponseTime_container">
          {authClient && authClient.responseTime ?
            (authClient.responseTime === 'fast' ?
              <>
                <img src='/img/responseTime/fast-response.svg' alt='responseTime' className="cardResponseTime_img" />
                <div className="cardResponseTime_scriptFast">
                  Nivel de respuesta alto <a className="cardResponseTime_text">en comunidad</a>
                </div>
              </> :
            authClient.responseTime === 'mid' ?
              <>
                <img src='/img/responseTime/normal-response.svg' alt='responseTime' className="cardResponseTime_img" />
                <div className="cardResponseTime_scriptMid">
                  Nivel de respuesta medio <a className="cardResponseTime_text">en comunidad</a>
                </div>
              </> :
            authClient.responseTime === 'low' ?
              <>
                <img src='/img/responseTime/slow-response.svg' alt='responseTime' className="cardResponseTime_img" />
                <div className="cardResponseTime_scriptLow">
                  Nivel de respuesta bajo <a className="cardResponseTime_text">en comunidad</a>
                </div>
              </> :
              null
            ) :
            null
          }
        </div>
      </section>
    </>
  );
};

const mapDispatchToProps = dispatch => ({
  responseTimeInCommunity: lawyerUid => dispatch(responseTimeInCommunity(lawyerUid)) 
})

export default connect(null, mapDispatchToProps)(CardResponseTime);
